export enum Flags {
  PORTAL_MY_ACCESS = 'portal-my-access',
  HIDE_BUNDLE_CONTENT = 'hide-bundle-content',
  JIT_CONNECT = 'jit-connect',
  ADMIN_CUSTOM_ACCESS_DETAILS = 'admin-custom-access-details',
  ALLOW_SAOLA_SESSION_RECORDING = 'allow-saola-session-recording',
  ACCESS_UNIT_SELECTOR = 'access-unit-selector',
  SHOW_SET_ACCESS_DURATION = 'show-set-access-duration',
  REQUEST_MFA = 'request-mfa',
  ENTITLEMENT_REQUEST_FORM = 'entitlement-request-form',
  HIDE_INTEGRATION_REQUEST_FORM = 'hide-integration-request-form',
  CLIENT_PERSONAL_API_TOKENS = 'client-personal-api-tokens',
  ENABLE_ANALYTICS = 'enable-analytics',
  APPROVER_JUSTIFICATION = 'approver-justification',
}
